<template>
  <div>
    <empty-card :title="$t('whatsapp.title')">
      <FetchingDataSpinner :loading="fetching" />
      <error-alert
        v-if="error"
        :error="error"
      />
      <b-row
        v-if="!fetching"
        class="align-center mt-2"
      >
        <b-col
          md="4"
          class="d-flex flex-column align-items-center justify-content-center"
        >
          <template v-if="connected">
            <FeatherIcon
              icon="CheckCircleIcon"
              class="text-success"
              size="100"
            />
            <p class="mt-1 text-dark font-weight-bold">
              You are now connected
            </p>
          </template>
          <template v-else>
            <img
              v-if="qr"
              :src="qr"
              class="img-fluid"
              style="height:300px"
            >
            <div
              v-else
              class="d-flex justify-center align-center"
            >
              <b-spinner size="40" />
            </div>
          </template>

        </b-col>
        <b-col md="8">
          <ul>
            <li><p>No additional subscription required
            </p>
            </li>
            <li><p>Send a max of (1000???) messages per day
            </p>
            </li>
            <li><p>Messages are sent using batches (50 each 5 minutes????) so your number is not blocked from WhatsApp
            </p>
            </li>
          </ul>
        </b-col>
      </b-row>
    </empty-card>
    <empty-card
      v-if="connected"
      title="Send test message"
    >
      <validation-observer
        ref="form"
        class="w-100"
      >

        <b-row class="mt-2 align-items-center w-100">
          <b-col md="6">
            <ok-text-input
              :label="$t('fields.phone')"
              is-required
            >
              <ok-phone-number-input
                v-model="form.phone"
              />
            </ok-text-input>

          </b-col>
          <b-col md="6">

            <ok-text-input
              v-model="form.message"
              is-required
              :label="$t('notifications.message')"
            />
          </b-col>
          <b-col
            md="12"
            class="text-center"
          >
            <b-button
              variant="primary"
              size="block"
              style="margin-top: 10px"
              :disabled="loading"
              @click="sendTest"
            >
              <b-spinner
                v-if="loading"
                small
                class="mr-50"
              />
              {{ $t('forms.send') }}
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </empty-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BSpinner, BButton,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import EmptyCard from '@/@okmenu/components/cards/EmptyCard'
import FetchingDataSpinner from '@/@okmenu/components/utils/FetchingDataSpinner'
import AuthApis from '@/API/auth-api'
import { WHATSAPP_SOCKET } from '@/constants/config'
import WPApi from '@/API/wp-api'
import ErrorAlert from '@/@okmenu/components/alerts/ErrorAlert'
import OkTextInput from '@/@okmenu/components/inputs/OkTextInput'
import OkPhoneNumberInput from '@/@okmenu/components/inputs/OkPhoneNumberInput'
import ErrorHandler from '@/utils/error-handler'

export default {
  name: 'WASetting',
  components: {
    OkPhoneNumberInput,
    OkTextInput,
    ErrorAlert,
    FetchingDataSpinner,
    EmptyCard,
    BRow,
    BSpinner,
    BCol,
    BButton,
    ValidationObserver,
  },
  data() {
    return {
      websocketInstance: null,
      qr: null,
      session: null,
      token: null,
      fetching: false,
      error: null,
      initSocket: false,
      connected: false,
      loading: false,
      form: {
        phone: '',
        message: '',
        isGroup: false,
      },
    }
  },
  beforeUnmount() {
    if (this.websocketInstance) {
      this.websocketInstance.leave()
    }
  },
  async mounted() {
    this.session = `session_${this.$store.getters['auth/user'].id}`
    await this.fetchToken()
    this.init()
  },
  methods: {
    async sendTest() {
      this.error = null
      const valid = await (this.$refs.form.validateWithInfo())
      if (!valid.isValid) {
        this.error = { title: this.$tc('errors.field-invalid', 2), message: ErrorHandler.getValidationErrors(valid.errors) }
        return
      }
      this.loading = true
      await WPApi.sendTestMessage(this.session, this.token, this.form).then(res => {
        if (res.status === 'success') {
          this.$notifySuccess('Your message has been sent successfully')
        } else {
          this.$notifyError('Your message fail')
        }
      }).catch(e => { this.error = e })
        .finally(() => { this.loading = false })
    },
    async fetchToken() {
      this.token = this.$store.getters['auth/wpToken']
      if (!this.token) {
        this.error = null
        this.fetching = true
        await AuthApis.wpToken().then(res => {
          this.token = res.token
          this.$store.commit('auth/SET_WHATSAPP_TOKEN', res.token)
        }).catch(e => { this.error = e })
          .finally(() => { this.fetching = false })
      }
    },
    async init() {
      await this.startSession()
      if (this.initSocket) {
        if (!this.websocketInstance) {
          this.websocketInstance = window.io(WHATSAPP_SOCKET)
          this.websocketInstance.on('qrCode', qrCode => {
            if (this.session === qrCode.session) {
              this.qr = qrCode.data
            }
          })

          this.websocketInstance.off('session-logged').on('session-logged', status => {
            if (status.session === this.session) {
              if (this.token) {
                this.connected = true
              }
            }
          })
        }
      }
    },
    async startSession() {
      try {
        const checkConn = await WPApi.checkSessionStatus(this.session, this.token)
        console.log(checkConn)
        if (!checkConn.status) {
          const res = await WPApi.startSession(this.session, this.token)
          if (res.qrcode) {
            this.qr = res.qrcode
          }
        } else {
          console.log('connected')
          this.connected = true
        }
        this.initSocket = true
      } catch (e) {
        this.error = 'Check that the session and token are correct.'
      }
    },

  },
}
</script>

<style scoped>

</style>
